export default {
    computed: {
        checkboxClass() {
            return {
                'custom-control': this.custom,
                'form-check-inline': this.inline
            };
        }
    }
};




//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/mixins/form-checkbox.js
// module id = 106
// module chunks = 2